export default __webpack_public_path__ + "images/ws-a6817aa95b8cdf652ba6f8c60527188d.svg";